exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-data-table[data-v-7ff63e18]{font-size:14px}", ""]);

// exports
